import {Box, styled, Typography} from "@mui/material";
import {color} from "../../theme/includes/color";

export const NavWrapper = styled(Box)({
  width: "100%",
  background: 'linear-gradient(180deg, #D2D5E1 0%, rgba(210, 213, 225, 0) 100%)',
  backdropFilter: 'blur(5px)',
  padding: "40px",
  display: "flex",
  alignItems: "start",
  justifyContent: "space-between",
  position: 'sticky',
  top: 0,
  zIndex: 1,
})

export const NavTitles = styled(Box)({})
export const NavTitle = styled(Typography)({
  fontSize: '56px',
  lineHeight: 1,
})

export const NavSubTitle = styled(Typography)({
  fontSize: '56px',
  lineHeight: 1,
  color: color('grey-100')
})

export const NavInputAndLink = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: '16px'
})